import { render, staticRenderFns } from "./updateAdmin.vue?vue&type=template&id=461ab93c&"
import script from "./updateAdmin.vue?vue&type=script&lang=js&"
export * from "./updateAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('461ab93c')) {
      api.createRecord('461ab93c', component.options)
    } else {
      api.reload('461ab93c', component.options)
    }
    module.hot.accept("./updateAdmin.vue?vue&type=template&id=461ab93c&", function () {
      api.rerender('461ab93c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commission/user/updateAdmin.vue"
export default component.exports